import React, {
  createContext,
  FC,
  useContext,
  useMemo,
  useReducer,
} from "react";
import { ChildrenPropsType } from "src/globalTypes";
import contextReducer, { initialState } from "./contextReducer";
import { ActionsQueueContextType } from "./types";

const ActionsQueueContext = createContext<ActionsQueueContextType | undefined>(
  undefined
);

export const useActionsQueueContext = (): ActionsQueueContextType => {
  const context = useContext(ActionsQueueContext);

  if (context === undefined) {
    throw new Error(
      "useActionsQueueContext must be inside ActionsQueue context"
    );
  }

  return context;
};

const ActionsQueueContextProvider = ({ children }: ChildrenPropsType) => {
  const [state, dispatch] = useReducer(contextReducer, initialState);

  const value = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state]
  );

  return (
    <ActionsQueueContext.Provider value={value}>
      {children}
    </ActionsQueueContext.Provider>
  );
};

export default ActionsQueueContextProvider;
